<!-- <div class="title_bar--item title_bar--search" [ngClass]="{ 'focused': searchFocus }"> -->
<div *sm-has-permission="TENANT_PERMISSIONS.Base_Work_Accounts_SearchAccounts" class="title_bar--item title_bar--search" [ngClass]="{ 'focused': searchFocus }">
    <div class="search_wrap" [attr.aurora-light]="searchFocus ? '' : null">
        <input class="form-control input-search"
               type="search"
               [placeholder]="'Search ' + ('Accounts' | smNomenclatureByRegion:null | async) + '...'"
               #search
               (mouseover)="onSearchOver()"
               (mouseout)="onSearchOut()"
               (focus)="onSearchFocus()"
               (blur)="!overSearch && onSearchBlur()"
               (keyup)="onSearchKeyup($event)"
               [(ngModel)]="searchValue" />
        <aurora-icon-button *ngIf="searchHasValue" icon="times" variant="ghost" aria-label="Clear search" (click)="clearSearchInput()" (mouseover)="onSearchOver()"></aurora-icon-button>
        <aurora-icon *ngIf="!searchHasValue" class="icon-search" icon="search"></aurora-icon>
        <div *ngIf="searchFocus" class="results" aurora-light [class.has_results]="foundAccounts.length">
            <div class="message">
                <svg *ngIf="searching" class="icon-completing">
                    <use xlink:href="#icon-completing"></use>
                </svg> {{searchMessage}}
            </div>
            <div class="results--list">
                <ng-container *ngFor="let foundAccount of foundAccounts; let i=index">
                    <sm-quick-search-card id="QuickSearchCard:{{ foundAccount.data.id }}"
                                          [MatchedItem]="foundAccount"
                                          [SearchType]="searchType"
                                          (mousedown)="onSearchAccountAdded(foundAccount.data)">
                    </sm-quick-search-card>
                    <ng-container *ngIf="foundAccounts.length - 1 != i">
                        <hr>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>
